import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Exchange({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 24 24' {...props}>
      <Path
        d='M17 9.20312L16.167 10.8701L14.5 10.0371'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M8.625 8.30406C9.8207 7.10548 11.5941 6.6914 13.1969 7.23652C14.7998 7.78164 15.953
         9.19102 16.17 10.8701'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7 14.7998L7.833 13.1328L9.5 13.9658'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M15.3731 15.6988C14.1774 16.8974 12.4041 17.3115 10.8012 16.7664C9.19837 16.2212
         8.04516 14.8119 7.82812 13.1328'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614
         21 16 21H8C5.23858 21 3 18.7614 3 16Z'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Exchange.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Exchange
